export default __webpack_public_path__ + "static/media/permission.008873fc.svg";